<template lang="pug">
  div.legend__group
    .legend__type
      .map-selects
        .map-select
          span(v-if="selectedDateStart") Год ввода в эксплуатацию
          map-select(
            :options="dateTkoStarts"
            :selected="selectedDateStart"
            title="Год ввода в эксплуатацию"
            @change="(value)=>changeDateTko('object_date_start', value)"
          )
        .map-select
          span(v-if="selectedDateEnd") Год окончания эксплуатации
          map-select(
            :options="dateTkoEnds"
            :selected="selectedDateEnd"
            title="Год окончания эксплуатации"
            @change="(value)=>changeDateTko('object_date_finish', value)"
          )
</template>

<script>
import MapSelect from './map-select'

import url from '@/utils/url'

export default {
  name: 'map-tko-dates',
  components: { MapSelect },
  props: {
    dateTkoStarts: {
      type: Array,
      default: function () {
        return []
      },
    },
    dateTkoEnds: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  data: () => ({
    selectedDateStart: url.getHashParam('object_date_start') || '',
    selectedDateEnd: url.getHashParam('object_date_finish') || '',
  }),
  watch: {
    $route: 'onRoute',
  },
  methods: {
    onRoute() {
      this.selectedDateStart = url.getHashParam('object_date_start')
      this.selectedDateEnd = url.getHashParam('object_date_finish')
    },
    changeDateTko(type, value) {
      this.$emit('changeDateTko', { type, value })
    },
  },
}
</script>
